<template>
  <div id="app">
    <transition :name="this.$store.routeAction">
      <router-view v-wechat-title="$route.meta.title"></router-view>
    </transition>
    <loading v-show="LOADING"></loading>
  </div>
</template>

<script>
import Loading from "./components/loading";
import { mapState } from "vuex";
export default {
  name: "app",
  components: {
    Loading
  },
  data() {
    return {
      // keepAlive: 'index',  //需要缓存的页面 例如首页
      // transitionName: "fade" //初始过渡动画方向
    };
  },
  computed: {
    // vuex
    ...mapState(["LOADING"])
  },
  created(){
    window.addEventListener('touchmove', e => e.preventDefault())
  },
  mounted() {
    // 检测浏览器路由改变页面不刷新问题,hash模式的工作原理是hashchange事件
    window.addEventListener(
      "hashchange",
      () => {
        let currentPath = window.location.hash.slice(1);
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath);
        }
      },
      false
    );
  }
};
</script>

<style lang="less">
@import url("../src/assets/iconfont/iconfont.css");
// *{
//   touch-action: none;
// }
html,body{
  height: 100%
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  max-width: 15rem;
  margin: auto;
  position: relative;
.push-enter-active,.push-leave-active
, .pop-enter-active,.pop-leave-active{
  transition: all 0.4s;
}

.push-leave-to{
transform: translate(-20%,0);
}

.push-enter {
  transform: translate(100%, 0);
}
.push-enter-active {
  z-index: 10;
}
.push-leave-active {
  z-index: 0;
}
.pop-leave-active {
  transform: translate(100%, 0);
  z-index: 11;
}

.pop-enter{
  transform: translate(-20%,0);
}
}
</style>
